'use client';

// Shared eval-pool snapshot for post-simulation feedback and paywall gating.
// Mirrors useWallet's module-level cache so ScanButton, job runners, and the
// banner stay in sync without prop-drilling.

import { EVAL_POOL_FREE_SIZE } from '@roomtreatment/core';

export interface EvalPoolSnapshot {
  remaining: number | null;
  total: number;
  /** Set when a metered simulation completes — drives the post-sim banner. */
  lastSpendAt?: number;
}

type Listener = (snapshot: EvalPoolSnapshot) => void;

// `total` seeds from the shared catalog, not a literal: this module is read
// before /api/auth/me answers, and a stale hardcoded number here is a wrong
// denominator in the post-solve line ("2 of 3 free simulations left").
let snapshot: EvalPoolSnapshot = { remaining: null, total: EVAL_POOL_FREE_SIZE };
const listeners = new Set<Listener>();

export function getEvalPoolSnapshot(): EvalPoolSnapshot {
  return snapshot;
}

export function setEvalPoolSnapshot(next: Partial<EvalPoolSnapshot>): void {
  snapshot = { ...snapshot, ...next };
  listeners.forEach((fn) => fn(snapshot));
}

export function subscribeEvalPool(fn: Listener): () => void {
  listeners.add(fn);
  fn(snapshot);
  return () => listeners.delete(fn);
}
